import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './styles';
import { MediaContext } from '@spa/shared/contexts/media';

const Button = ({ children, onClick, isPrimary, isSecondary, isTertiary, isDanger, isGhost, isSelected, isSmall }) => {
  const { is } = useContext(MediaContext);

  return (
    <Wrapper
      onClick={onClick}
      isPrimary={isPrimary}
      isSecondary={isSecondary}
      isTertiary={isTertiary}
      isDanger={isDanger}
      isGhost={isGhost}
      isSelected={isSelected}
      isSmall={isSmall}
      isMobile={is?.mobile}
    >
      {children}
    </Wrapper>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  isPrimary: PropTypes.bool,
  isSecondary: PropTypes.bool,
  isTertiary: PropTypes.bool,
  isDanger: PropTypes.bool,
  isGhost: PropTypes.bool,
  isSelected: PropTypes.bool,
  isSmall: PropTypes.bool
};

export default Button;
